import { PortableTextListComponent } from '@portabletext/react'
import classNames from 'classnames'
import React from 'react'
import { businessLineParagraphClasses } from '../blocks/BusinessLineBlockSerializer'

const businessLineListClasses = businessLineParagraphClasses

export const BusinessLineListSerializer: PortableTextListComponent = ({
  children,
  value,
}) =>
  value.listItem === 'bullet' ? (
    <ul className={classNames(businessLineListClasses, 'bullet align-middle')}>
      {children}
    </ul>
  ) : (
    <ol className={classNames(businessLineListClasses, 'number')}>{children}</ol>
  )
